// tslint:disable

import axios, { AxiosResponse } from 'axios';
import { get } from 'lodash';
import * as React from 'react';
import { CheckboxField } from '../../components/fields/checkbox.field';
//import { ConfirmButton } from '../../components/fields/confirm.button';
import { InputField } from '../../components/fields/input.field';
import { IriField } from '../../components/fields/iri.field';
import { JsonField } from '../../components/fields/json.field';
import { MediaItemField } from '../../components/fields/media-item.field';
import { Field, FormLib } from '../../components/libs/form.lib';
import { ListResourceLoader } from '../../components/libs/list-resource-loader';
import { ListLib } from '../../components/libs/list.lib';
import { ResourceLoader } from '../../components/libs/resource-loader';
import { DefaultSave } from '../../components/libs/updaters/default-save';
import { Validators } from '../../components/libs/Validators';
import { LoaderComponent } from '../../components/structurals/loader.component';
import { IriPresenter } from '../../components/structurals/presenters/iri-presenter';
import { ListActions, ListResponsePresenterTable } from '../../components/structurals/presenters/list-response-presenter-table';
import { ResourceModal } from '../../components/structurals/resource-modal';
import { ToggleBoxComponent } from '../../components/structurals/toggle-box.component';
import { Environment } from '../../environment/environment';
import { Notification } from '../../index';
import {DatepickerField} from "../../components/fields/datepicker.field";
import {WysiwygField} from "../../components/fields/wysiwyg.field";
import {TextAreaField} from "../../components/fields/textarea.field";

//import { FormButtonsComponents } from '../../components/structurals/form-buttons.component';

export class AtasMember extends React.Component<any, any> {
    public hasEmitted: any = {};
    public state: any = {companySiteSpecId: null};
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);
    private executorSiteSpec: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib, siteSpecForm: FormLib): Promise<any> {
        this.executor.updateForm(form);
        this.executor.updateEndPoint('company');
        this.executor.setRedirectOnSave(false);
        const company = await this.executor.exec();





        if (this.state.companySiteSpecId === 'create') {
            siteSpecForm.fields.company = new Field({iri: 'company', property: 'company'});
            siteSpecForm.fields.company.registerField();
            siteSpecForm.fields.company.setValue(get(company, '@id'), true, false);
            this.executorSiteSpec.setCreate();
        } else {
            this.executorSiteSpec.setUpdate();
            this.executorSiteSpec.setEntityId(this.state.companySiteSpecId);
        }

        this.executorSiteSpec.setRedirectOnSave(false);
        this.executorSiteSpec.updateForm(siteSpecForm);
        this.executorSiteSpec.updateEndPoint('company-site-spec');
        await this.executorSiteSpec.exec();

        if (this.props.ENTITY_ID === 'create') {
            window.location.href = `/member/${get(company, 'id')}`;
        }
        this.getCompanySiteSpec();
    }

    public async getCompanySiteSpec() {
        try {
            const response: AxiosResponse = await axios.get(`${Environment.get('api.base')}/company-site-spec`, {
                withCredentials: true,
                params: {
                    company: this.props.ENTITY_ID
                }
            });

            if (!response.data || !response.data['hydra:member']) {
                throw new Error('Faszom');
            }

            if (response.data['hydra:member'] && response.data['hydra:member'][0]) {
                this.setState({companySiteSpecId: get(response.data, '[hydra:member][0].id', 'create')});
            } else {
                this.setState({companySiteSpecId: 'create'});
            }

        } catch (err) {
            console.warn(err.message);
        }
    }

    componentDidMount() {
        this.getCompanySiteSpec();


    }

    render() {
        return (
            <ResourceLoader entity="company" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                {!!this.state.companySiteSpecId &&
                <ResourceLoader entity="company-site-spec" entityId={this.state.companySiteSpecId} render={(siteSpecForm: FormLib) => <div>
                    <div id="page-title">
                        <h2>
                            {this.props.IS_CREATE ? 'Create new member' : 'Edit member'}
                        </h2>
                        <p>CompanySiteSpec ID: {this.state.companySiteSpecId}</p>
                    </div>


                    <LoaderComponent isLoading$={this.executor.loading$}/>
                    <div className="row">
                        <div className="col-md-8">

                            {this.state.companySiteSpecId === 'create' &&
                            <div className="alert alert-warning">
                                Please fill form of the company data to the see further details of the form!
                            </div>
                            }


                            <ToggleBoxComponent title="Company details" color="green" alwaysOpen={true} preIcon="fa-building-o">
                                <div className="row">
                                    <div className="col-xs-12 col-md-9">
                                        <InputField
                                            field={form.fields.name}
                                            validators={[
                                                Validators.required('Required')
                                            ]}/>

                                        <InputField
                                            placeholder="http://www.your-company.co.uk"
                                            field={form.fields.website}
                                            validators={[Validators.isWebsite('Invalid website address')]}
                                        />

                                        <InputField
                                            field={form.fields.phone}
                                            validators={[
                                                Validators.required('Required')
                                            ]}/>

                                        <InputField field={form.fields.address}/>

                                        {form.fields.city && <IriField
                                            field={form.fields.city}
                                            defaultAll={true}
                                            itemRender={(item: any) => item.title}
                                            onFetched={(field: Field) => this.handleEntityFieldFetched(form, field, 'city')}/>}

                                        <InputField field={form.fields.postCode}/>


                                        <InputField
                                            placeholder="your@email.co.uk"
                                            field={form.fields.email}
                                            validators={[Validators.isEmail('Invalid email address')]}/>


                                        <JsonField
                                            title={'Social links'}
                                            schema={{
                                                facebook: (schemaField: Field) => <InputField field={schemaField}/>,
                                                instagram: (schemaField: Field) => <InputField field={schemaField}/>,
                                                youtube: (schemaField: Field) => <InputField field={schemaField}/>,
                                                twitter: (schemaField: Field) => <InputField field={schemaField}/>
                                            }}
                                            field={form.fields.socialLinks}
                                        />


                                        <IriField
                                            field={siteSpecForm.fields.type}
                                            defaultAll={true}
                                            itemRender={(item: any) => get(item, 'title')}
                                        />

                                        <TextAreaField
                                        field={siteSpecForm.fields.lead}/>

                                        <WysiwygField
                                        field={siteSpecForm.fields.description}/>

                                        <CheckboxField
                                            title="Featured"
                                            field={siteSpecForm.fields.featured}
                                        />

                                        <CheckboxField
                                            title="E-learning is enabled?"
                                            field={siteSpecForm.fields.elearning}
                                        />
                                        <CheckboxField
                                            title="Supplier Extra?"
                                            field={siteSpecForm.fields.supplierExtra}
                                        />
                                        <DatepickerField
                                            title="Last Payment Date"
                                            field={siteSpecForm.fields.lastPaymentDate}
                                            dateFormat="DD-MM-YYYY"
                                        />
                                    </div>
                                    <div className="col-xs-12 col-md-3">
                                        <MediaItemField
                                            field={form.fields.logo}
                                        />

                                        <MediaItemField
                                            field={siteSpecForm.fields.cover}
                                        />
                                    </div>
                                </div>
                            </ToggleBoxComponent>

                            {this.state.companySiteSpecId !== 'create' &&
                            <div>
                                <ToggleBoxComponent title="Pages" color="green" alwaysOpen={true} preIcon="fa-file">

                                    <ListResourceLoader
                                        entity="company-page"
                                        forceQuery={{companySiteSpec: this.state.companySiteSpecId, pagination: false, '_deletedAt': true}}
                                        //forceQuery={{company: this.props.ENTITY_ID, pagination: false}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.companyPageHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.companyPageRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="modal-company-page"
                                                entityId="create"
                                                extClass="btn-sm"
                                                config={{companySiteSpec: `/company-site-spec/${this.state.companySiteSpecId}`, company: `/company/${this.props.ENTITY_ID}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new page</div>}/>

                                        </div>}
                                    />

                                </ToggleBoxComponent>

                                <ToggleBoxComponent title="Trainings" color="green" alwaysOpen={true} preIcon="fa-newspaper-o">

                                    <ListResourceLoader
                                        entity="company-article"
                                        forceQuery={{company: this.props.ENTITY_ID, pagination: false}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.companyArticleHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.companyArticleRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="atas-training"
                                                entityId="create"
                                                extClass="btn-sm"
                                                config={{company: `/company/${this.props.ENTITY_ID}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new training</div>}/>
                                        </div>}
                                    />
                                </ToggleBoxComponent>

                                <ToggleBoxComponent title="FAQs" color="green" alwaysOpen={true} preIcon="fa-question">

                                    <ListResourceLoader
                                        entity="faq"
                                        forceQuery={{companySiteSpec: this.state.companySiteSpecId, pagination: false}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.companyFaqHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.companyFaqRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="modal-faq"
                                                entityId="create"
                                                extClass="btn-sm"
                                                config={{companySiteSpec: `/company-site-spec/${this.state.companySiteSpecId}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new FAQ</div>}/>
                                        </div>}
                                    />
                                </ToggleBoxComponent>
                            </div>
                            }
                        </div>
                        <div className="col-md-4">
                            {this.props.ENTITY_ID !== 'create' &&
                            <ToggleBoxComponent title="Persons" color="blue" closed={true} preIcon="fa-users">
                                <ListResourceLoader
                                    entity="person-company"
                                    forceQuery={{company: this.props.ENTITY_ID, pagination: false}}
                                    render={(list: ListLib) => <div className="w-100">
                                        <LoaderComponent isLoading$={list.isLoading$}/>

                                        <ListResponsePresenterTable
                                            head={() => this.personCompanyHead()}
                                            row={(item: any, index: number, actions: ListActions) => this.personCompanyRow(item, index, actions, list)}
                                            items={list.member}/>

                                        <ResourceModal
                                            entity="modal-person-company"
                                            entityId="create"
                                            extClass="btn-sm"
                                            config={{company: this.props.ENTITY_ID}}
                                            onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                            title={<div><i className="fa fa-plus"/> Attach new person to the company</div>}/>

                                    </div>}/>

                            </ToggleBoxComponent>
                            }

                            {this.state.companySiteSpecId !== 'create' &&
                            <div>
                                <ToggleBoxComponent title="Team members" color="red" preIcon="fa-user-circle-o" closed={true}>

                                    <ListResourceLoader
                                        entity="team-member"
                                        forceQuery={{company: this.props.ENTITY_ID, pagination: false}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <LoaderComponent isLoading$={list.isLoading$}/>

                                            <ListResponsePresenterTable
                                                head={() => this.companyTeamMemberHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.companyTeamMemberRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="modal-team-member"
                                                entityId="create"
                                                extClass="btn-sm"
                                                config={{company: `/company/${this.props.ENTITY_ID}`, companySiteSpec: this.state.companySiteSpecId}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Select person</div>}/>

                                        </div>}/>

                                </ToggleBoxComponent>

                                <ToggleBoxComponent title="Admins" color="green" closed={true} preIcon="fa-user-secret">

                                    <ListResourceLoader
                                        entity="company-admin"
                                        forceQuery={{companySiteSpec: this.state.companySiteSpecId, pagination: false}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.companyAdminHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.companyAdminRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="modal-company-admin"
                                                entityId="create"
                                                extClass="btn-sm"
                                                config={{companySiteSpec: `/company-site-spec/${this.state.companySiteSpecId}`, company: this.props.ENTITY_ID}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Select person</div>}/>
                                        </div>}
                                    />
                                </ToggleBoxComponent>
                            </div>
                            }

                        </div>
                    </div>

                    {/*<FormButtonsComponents saveAndClose saveAndNew
                        onClick={(result: any) => console.log(result)} />*/}

                    <div className="col-xs-12">
                        <button className="btn btn-primary pull-left" onClick={() => this.saveForm(form, siteSpecForm)}>Save</button>
                    </div>
                    {/*                    <ConfirmButton triggerButtonTitle="delete"
                                   onConfirm={() => console.log('confirmed')}/>*/}
                </div>}/>
                }
            </div>}/>
        );
    }

    handleEntityFieldFetched(form: FormLib, field: any, entity: string) {
        if (!this.hasEmitted.hasOwnProperty(entity)) {
            (form.fields[entity] as Field).setValue(get(field, 'value.@id'));
            this.hasEmitted[entity] = false;
        }
    }

    handleCreateAndUpdate(pc: any, list: ListLib) {
        list.refetch();
    }

    async handlePersonCompanyDelete(item: any, list: ListLib) {
        list.isLoading$.next(true);
        try {
            await axios.delete(`${Environment.get('api.base')}${get(item, '@id')}`, {withCredentials: true});
        }
        catch (err) {
            alert(err.message);
        }
        finally {
            list.isLoading$.next(false);
            list.refetch();
        }
    }


    private companyPageHead() {
        return <tr>
            <th>ID</th>
            <th>Title</th>
            <th>Action</th>
        </tr>;
    }

    private companyPageRow(item: any, index: number, actions: ListActions, list: ListLib) {
        let deleted: boolean = false;
        if (get(item, 'deletedAt')) {
            deleted = true;
        }

        return <tr key={index} className={(deleted ? 'deleted' : '')}>
            <td>{get(item, 'id', '-')}</td>
            <td>{get(item, 'title', 'N/A')}</td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-company-page'}
                        entityId={item.id || item['@id'].replace('/company-page/', '')}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary btn-sm dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        {deleted &&
                        <li>
                            <a onClick={(event: any) => this.handleUnDelete(item, list, actions, event)}>
                                Undelete page
                            </a>
                        </li>
                        }
                        {!deleted &&
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Delete page
                            </a>
                        </li>
                        }
                    </ul>
                </div>
            </td>
        </tr>;
    }

    private async handleDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        const answer = await Notification.delete();

        if (answer === true) {
            try {
                list.isLoading$.next(true);
                await ListActions.delete(item['@id']);
            } catch (error) {

            } finally {
                list.refetch();
            }
        }

    }

    private async handleUnDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        try {
            list.isLoading$.next(true);
            await ListActions.unDelete(item['@id']);
        } catch (error) {

        } finally {
            list.refetch();
        }

    }


    private personCompanyHead() {
        return <tr>
            <th>ID</th>
            <th>Person</th>
            <th>Job</th>
            <th>Action</th>
        </tr>;

    }

    private personCompanyRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>

                <IriPresenter iri={get(item, 'person.@id')} render={(person: any) =>
                    get(person, 'firstName') + ' ' + get(person, 'surName')
                }/>

            </td>
            <td>

                <IriPresenter iri={get(item, 'job.@id')} render={(job: any) =>
                    get(job, 'title')
                }/>

            </td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-person-company'}
                        config={{disabledPerson: true}}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        entityId={item.id || item['@id'].replace('/person-company/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                        <li>
                            <a onClick={(event: any) => location.href = get(item.person, "@id") }>
                                Edit person
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }


    private companyTeamMemberHead() {
        return <tr>
            <th>ID</th>
            <th>Person</th>
            <th>Job</th>
            <th>Mail</th>
            <th>Action</th>
        </tr>;

    }

    private companyTeamMemberRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                <IriPresenter iri={get(item, 'personCompany.@id')} render={(personCompany: any) =>
                    <IriPresenter iri={get(personCompany, 'person.@id')} render={(person: any) =>
                        get(person, 'firstName') + ' ' + get(person, 'surName')
                    }/>
                }/>
            </td>
            <td>
                <IriPresenter iri={get(item, 'personCompany.@id')} render={(personCompany: any) =>
                    <IriPresenter iri={get(personCompany, 'job.@id')} render={(job: any) =>
                        get(job, 'title')
                    }/>
                }/>
            </td>
            <td>
                {get(item, 'mailHidden') ? <span className="bs-label label-danger">Hidden</span> : <span className="bs-label label-success">Visible</span>}
            </td>
            <td className="text-center">
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-team-member'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        entityId={item.id || item['@id'].replace('/team-member/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }

    private companyFaqHead() {
        return <tr>
            <td>ID</td>
            <td>Question</td>
            <td>sortNo.</td>
            <td>Action</td>
        </tr>;
    }

    private companyFaqRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                {item.title}
            </td>
            <td>
                {item.sortNo}
            </td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-faq'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        entityId={item.id || item['@id'].replace('/company-faq/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Disable user
                            </a>
                        </li>
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }

    private companyAdminHead() {
        return <tr>
            <td>ID</td>
            <td>Person</td>
            <td>Active</td>
            <td>Action</td>
        </tr>;
    }

    private companyAdminRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                <IriPresenter iri={get(item, 'personCompany.@id')} render={(personCompany: any) =>
                    <IriPresenter iri={get(personCompany, 'person.@id')} render={(person: any) =>
                        get(person, 'firstName') + ' ' + get(person, 'surName')
                    }/>
                }/>
            </td>
            <td>
                {get(item, 'active') ? <span className="bs-label label-success">Yes</span> : <span className="bs-label label-danger">No</span>}
            </td>
            <td>
                <IriPresenter iri={get(item, 'personCompany.@id')} render={(personCompany: any) =>
                    <IriPresenter iri={get(personCompany, 'person.@id')} render={(person: any) => {
                        return <div>{!get(person, 'user.@id') &&
                        <ResourceModal
                            title={'Create user'}
                            entity={'modal-user'}
                            config={{
                                firstName: get(person, 'firstName'),
                                surName: get(person, 'surName'),
                                email: get(person, 'email'),
                                person: get(person, '@id'),
                            }}
                            entityId={'create'}
                            extClass="btn-sm"
                        />

                        }</div>;

                    }
                    }/>
                }/>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'modal-company-admin'}
                        config={{disabledPerson: true}}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        entityId={item.id || item['@id'].replace('/company-admin/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Disable user
                            </a>
                        </li>
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }


    private companyArticleHead() {
        return <tr>
            <td>ID</td>
            <td>sortNo.</td>
            <td>Title</td>
            <td>Action</td>
        </tr>;
    }

    private companyArticleRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>{get(item, 'id', '-')}</td>
            <td>
                {get(item, 'sortNo')}
            </td>
            <td>
                {get(item, 'title')}
            </td>
            <td>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'atas-training'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        config={{company: `/company/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/company-article/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Disable user
                            </a>
                        </li>
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/atas.member.tsx